import http from '../services/http';

const files = {
  // GET /files/{id} streams the file, so it comes back as a blob and is handed
  // to file-saver by the caller.
  download(fileId) {
    return http.request({
      method: 'get',
      url: `/files/${fileId}`,
      responseType: 'blob',
    });
  },
};

export default files;
